import React, {Component} from 'react';
import {connect} from 'react-redux';
 import {bindActionCreators} from 'redux';
import queryString from 'query-string'
import {makeRequest,displayMessage,dispatchAction}  from 'actions';
import RemoveModalDialog from'shared/RemoveModalDialog';
import PhoneInput from 'shared/PhoneInput/PhoneInput.js'
import Select   from 'react-select';
import {FETCH_CONTRACTORS} from "actions/actionTypes";
import {Row, Col, Form, FormGroup, Checkbox, Modal, ControlLabel, FormControl, Button} from 'react-bootstrap';
import AdminContractorsSearchBox from 'dashboard/contractors/AdminContractorsSearchBox'
import AdminContractorsActionsBox from 'dashboard/contractors/AdminContractorsActionsBox'
import config from  '../../../config';
 import AdminContractorListTable from'dashboard/contractors/AdminContractorListTable';
import PaginationBox from'shared/PaginationBox';
import {onRowSelect,onAllRowSelect,customMultiSelect} from 'util/Utils';
var locationsList =  _.map(config.warehouseData, function (item, key) {
    return {value: key, label: _.startCase(key)}
});

class AdminContractorsPage extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }
    constructor(props, context) {
        super(props, context);
         var queryParams = queryString.parse(this.props.location.search);
        var showModal = false
        if (this.props.location.pathname.includes('/add')){
            showModal =true;
        }
        this.state = {
           sortBy:  _.get(queryParams, 'sortBy', 'DisplayName:1'),
            currentPage: queryParams.page ?  parseInt(queryParams.page) -1 : 0,
          selectAllRecords:false,
            currentRecord:{MarketName:{value:'Denver', label:'Denver'},
                Type:{value:'Contractor',label:'Contractor'},
            'PaymentMethod': {value: 'Paypal', label: 'PayPal'}},
            showModal:showModal,
            recordIDs:[],

        };
        this.searchBox = false;
    };
    resetSearch() {
        this.props.dispatchAction({}, RESET_TRANSACTIONS)
        this.setState({

            sortBy: '',
            displayGeneratePayoutBox: false,

        });
    }
    onSortChange(field, sortOrder){
         this.setState({sortBy: field + ':' + (sortOrder ==  'asc' ? 1 : -1)}, function () {
            this.refs.pagination.resetPagination();
            this.search()
        })
    }
    search(params = {}) {
        var self = this;
        if (this.state.pending){
            return this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Please wait till search request is completed'
            });
        }
        this.setState({pending:true})
        var {queryParams} = this.searchBox.getSearchParams();

        _.extend(queryParams, params);
         if (this.state.sortBy) {
            queryParams.sortBy = this.state.sortBy;
             queryParams.sortBySecondary  = '_id:-1'; /* without secondary sort query, the order of documents with the same fields is not guaranteed across pages */
         }

        if (queryParams.page === 1) {
            delete queryParams.page
        }
        console.log('queryParams.page', queryParams.page  );
        if (_.isUndefined(queryParams.page)) { /* do not clear selected records when only pagination is changed */
            this.setState({recordIDs:[]})
        }
      if (!this.props.location.pathname.includes('/add')) {
          const stringified = queryString.stringify(_.omit(queryParams, ['include', 'lookup', 'all', 'sortBySecondary']));
          this.context.router.push('/admin/contractors?' + stringified);
      }
        var methodData = {
            "endpoint": "/contractors",
            'not_display_success_message': true
        };


        if (_.isUndefined(params.include)  ) {
            methodData['success_event'] = FETCH_CONTRACTORS;
        }
        return this.props.makeRequest(queryParams, methodData).then((res)=>{
            console.log('res.data', res.data  );
            self.setState({pending:false})
            return res
        }).catch(err => {
            self.setState({pending:false})
            return Promise.reject(err)
        });
    }

    toggleAllRecordsSelection(value) {
        if (value) {
            this.setState({ selectAllRecords:true});
        }else{
            this.setState({ selectAllRecords:false});
        }
    }
    editRecord(row) {

         if (!config.checkAccessRights.call(this,{ resources:['contractors_edit']}) ){
            return this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'errorAccessResource'
            });
        }
        var paymentMethodEmail = ''
        if (_.get(row, ['PaymentData'], false)) {
            if (row.PaymentMethod == 'Paypal'  ) {
                paymentMethodEmail = _.get(row, ['PaymentData', row.PaymentMethod, 'email'], '')
            }
        }

        var dataToUpdate = {
            PaymentMethod: _.find(_.map(config.payoutMethodsMap, function (key, value) {
                return {value: value, label: key}
            }), {'value':   _.get(row, ['PaymentMethod'])}),
            PaymentData: _.get(row, ['PaymentData'], {}),
            PaymentMethodEmail: paymentMethodEmail,
            MarketName:_.find(locationsList, {'value': _.get(row, ['MarketName'], '')}),
            PhoneNumber:  '+1' +_.get(row, ['PhoneNumber', 'Number'], ''),
            HourlyRate:_.get(row, ['HourlyRate'],''),
            Status:_.get(row, ['Status'],''),
            Type:{label:row.Type,value:row.Type},
    }

        this.setState({
            showModal: true,
            currentRecord: {
                ...row,...dataToUpdate
            },

        });
    }
    validateAndGetFormData() {
        var self = this, formData = {}, error = false,    messageData = {
            'messageType': 'warning',
            'messageCode': 'errorFieldRequired',
        }
        var fields = [
            {name:'PaymentMethod', path:['PaymentMethod', 'value'], required:true},
            {name:'MarketName',path:['MarketName', 'value'], required:true},
            {name:'PhoneNumber', required:true},
             {name:'HourlyRate', required:true},
            {name:'Type',  path:['Type', 'value'], required:true},
            {name:'Status', path:['Status', 'value'], },
        ]


        _.forEach(fields, function (field) {
            if(_.get(self.state.currentRecord, (field.path ? field.path:[field.name]), '') !== ''){
                _.set(formData, ( field.setPath ? field.setPath:[field.name]), _.get(self.state.currentRecord, field.path ? field.path:[field.name]))
            } else if(field.required){
                 self.props.displayMessage(_.extend(messageData, field.messageCode ? {messageCode:field.messageCode}:{},{ 'messageData': {'#1#': _.startCase(field.name)}}))
                error = true;
                return false;
            }
        });
        if (error){
            return;
        }

        if (formData['PaymentMethod'] == 'Paypal' ) {

            if (this.state.currentRecord.PaymentMethodEmail == '') {
                this.props.displayMessage(_.extend(messageData, {'messageCode': 'Please, specify your email or username for payment method'}));
                return false;
            }
            formData['PaymentData'] = {[formData['PaymentMethod']]: {'email': this.state.currentRecord.PaymentMethodEmail}}
        }

        var PhoneNumber = this.state.currentRecord.PhoneNumber.replace(/[^0-9.]/g, "")
        console.log('PhoneNumber 1', PhoneNumber  );
        if (PhoneNumber.indexOf('1') === 0) { /* remove country code 1 from the phone number */
            PhoneNumber = PhoneNumber.substring(1);
        }
        if (!_.includes(this.state.currentRecord.PhoneNumber, '+1')   ) {
            this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Phone number code is not valid'
            });
            return false;
        }
        console.log('PhoneNumber 2', PhoneNumber  );
        if (this.state.currentRecord.PhoneNumber.length < 9 ||  PhoneNumber.length > 10 ) {
            this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Phone number is not valid'
            });
            return false;
        }

        if (this.state.currentRecord.PhoneNumber) {
            formData['PhoneNumber'] = {'Number': PhoneNumber};
        }


        return formData
    }
    saveRecord() {
        this.setState({pending:true})
        var formData = this.validateAndGetFormData();
        console.log('form data', formData);
        if (!formData) {
            this.setState({pending:false})
            return false;
        }
        var methodData
        if (this.state.currentRecord._id) {
            methodData = {
                 type: 'patch',
                endpoint: '/contractors/' + encodeURIComponent(this.state.currentRecord._id),
                messageData: {'#1#': 'Contractor'},
                messageCode: 'recordUpdated'
            };
        } else {
            methodData = {
                "endpoint": "/contractors",
                type: "post",
                messageData: {'#1#': 'Contractor'},
                messageCode: 'recordAdded'
            };
            formData.UserID = _.get(this.props, 'params.userID')
        }


        this.props.makeRequest(formData, methodData).then(res => {
            this.setState({
                showModal: false,
                currentRecord: {},
                pending:false,
            })
            if(formData.UserID){
                this.context.router.push(`/admin/contractors`)
            } else {
                this.search()
            }
        }).catch(err => {
            this.setState({
                pending:false,
            })
        });

    }
    deleteRecord() {
        this.setState({removeRecordModalVisible: false});
        var methodData = {
            type: 'delete',
            "endpoint": "/contractors/" + encodeURIComponent(this.state.currentRecord._id),
            messageData: {'#1#': 'Contractor record'},
            messageCode: 'recordDeleted',
        };
        this.setState({currentRecord: {}});
        this.props.makeRequest({}, methodData).then(function () {
                this.search()
        }).catch(err => {
            this.search()
        });
    }
    changePaymentMethod(selectedOption) {
        var paymentMethodEmail = ''
        if (  _.get(selectedOption, ['value'], '')== 'Paypal' ) {
            paymentMethodEmail = _.get(this.state.currentRecord, ['PaymentData', _.get(selectedOption, ['value'], ''), 'email'], '')
        }
        this.setState({currentRecord:{
            ...this.state.currentRecord,
            PaymentMethod:selectedOption,
            paymentMethodEmail: paymentMethodEmail}
        });
    }
    render() {
console.log('this.state.pending', this.state.pending  );

        return (
            <div >
                {/*<AdminContractorsActionsBox     recordIDs={this.state.recordIDs} {...this.props } ></AdminContractorsActionsBox>*/}
                <AdminContractorsSearchBox  pending={this.state.pending}   ref={(searchBox) => {
                    if (searchBox && !this.searchBox) {
                        this.searchBox = searchBox;
                        this.search({page:this.state.currentPage+1})
                    }
                } }
                                              resetSearch={this.resetSearch.bind(this)}
                                              search={this.search.bind(this)}
                                              selectAllRecords = {this.state.selectAllRecords}
                                              toggleAllRecordsSelection = {this.toggleAllRecordsSelection.bind(this)}     {...this.props} ></AdminContractorsSearchBox>
                {(this.props.adminContractors.total !== 'initial' &&  this.props.adminContractors.total == 0) ?
                    <div className="messageBox">{config.clientMessages.noRecordsFoundForCriteria.replace("#1#", 'Contractors')}</div> :
                    <div className="top20">
                        <AdminContractorListTable
                            search={this.search.bind(this)}
                            onRowSelect ={onRowSelect.bind(this)}
                            customMultiSelect ={customMultiSelect.bind(this)}
                            showRemoveDialog={(row)=>{
                                this.setState({removeRecordModalVisible: true, currentRecord: row});
                            }}
                            onAllRowSelect ={onAllRowSelect.bind(this)}
                            editRecord={this.editRecord.bind(this)}
                            onSortChange={this.onSortChange.bind(this)} {...this.props}   ></AdminContractorListTable>
                        <PaginationBox
                            ref={'pagination'}
                            currentPage={this.state.currentPage}
                            perPage={this.searchBox ? this.searchBox.state.filterOptions.perPage : undefined}
                            total={this.props.adminContractors.total == 'initial' ? 0 : this.props.adminContractors.total}
                            search={this.search.bind(this)} >
                        </PaginationBox>
                    </div>}
                <Modal className="custom-modal-dialog" onExited={ ()=>{
                    this.setState({
                        showModal: false,
                        currentRecord: {},

                    })}} show={this.state.showModal}

                       onHide={(e) => this.setState({showModal: false})}>
                    <Modal.Header closeButton>
                        <Modal.Title>{this.state.currentRecord._id ? 'Edit' : 'Add new'}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form  >

                            <FormGroup>
                                <ControlLabel>Market</ControlLabel>
                                <Select
                                    tabIndex="0"
                                    searchable={false}
                                    selectedOptions
                                    clearable={false}
                                    placeholder="Market Name"
                                    options={ locationsList}
                                    onChange={(selectedOptions)=> this.setState({currentRecord:{
                                        ...this.state.currentRecord,
                                        MarketName: selectedOptions}})}
                                    value={this.state.currentRecord.MarketName }
                                />

                            </FormGroup>
                            <FormGroup>
                                <ControlLabel>Type</ControlLabel>
                                <Select
                                    tabIndex="0"
                                    searchable={false}
                                    selectedOptions
                                    clearable={false}
                                    options={  [  {value: 'Contractor', label:  'Contractor'},{value: 'Employee', label:  'Employee'},]}

                                    onChange={(selectedOption)=>{
                                        console.log('selectedOption', selectedOption  );
 
                                        var dataToUpdate = {
                                            ...this.state.currentRecord,
                                            Type:selectedOption,
                                        }
                                        if (selectedOption) {
                                            if (selectedOption.value == 'Contractor' && !_.includes(['Check', 'Paypal', 'Bill.com'], _.get(this.state.currentRecord.PaymentMethod, 'value'))) {
                                                dataToUpdate.PaymentMethod = null
                                            } else if (selectedOption.value == 'Employee' && !_.includes(['TriNet'], _.get(this.state.currentRecord.PaymentMethod, 'value'))) {
                                                dataToUpdate.PaymentMethod = null
                                            }
                                        }

                                        this.setState({currentRecord:dataToUpdate
                                        });
                                    }}
                                    value={this.state.currentRecord.Type }
                                /></FormGroup>


                            <FormGroup>
                                <ControlLabel>Cell Phone Number</ControlLabel>

                                <PhoneInput defaultCountry={'us'}
                                            placeholder=""
                                            onlyCountries={['us']}
                                    //disableCountryCode={true}
                                            onChange={(value) => {
                                                this.setState({currentRecord:{
                                                    ...this.state.currentRecord,
                                                    PhoneNumber: value}})
                                            }}
                                            value={_.get(this.state.currentRecord, ['PhoneNumber'], '')}

                                />
                            </FormGroup>
                            <FormGroup>
                                <ControlLabel>Payment method</ControlLabel>
                                <Select
                                    tabIndex="0"
                                    searchable={false}
                                    selectedOptions
                                    clearable={false}
                                    options={  _.filter(_.map( config.payoutMethodsMap, function (key, value) {
                                        return {value: value, label: key}
                                    }),item=>{
                                        if (_.get(this.state.currentRecord,'Type.value')=='Contractor' && _.includes(['Check','Paypal', 'Bill.com'],item.value)){
                                            return true
                                        }else  if (_.get(this.state.currentRecord,'Type.value')=='Employee' && _.includes(['TriNet'],item.value)){
                                            return true
                                        }
                                    })}
                                    onChange={this.changePaymentMethod.bind(this)}
                                    value={this.state.currentRecord.PaymentMethod }
                                />

                                {_.get(this.state.currentRecord, ['PaymentMethod', 'value'], '') && (   _.get(this.state.currentRecord, ['PaymentMethod', 'value'], '') == 'Paypal'  ) &&
                                <FormGroup className="left20 top10">
                                    <FormControl type="text"
                                                 value={this.state.currentRecord.PaymentMethodEmail}
                                                 onChange={(e) => this.setState({currentRecord:{...this.state.currentRecord,  PaymentMethodEmail: e.target.value}})}
                                                 placeholder={'Payment method email or username'}/>
                                </FormGroup>
                                }
                            </FormGroup>

                            <FormGroup>
                                <ControlLabel>Hourly Rate</ControlLabel>
                                <FormControl type="text"
                                             value={this.state.currentRecord.HourlyRate }
                                             onChange={(e) => {
                                                 this.setState({
                                                     'currentRecord': {
                                                         ...this.state.currentRecord,
                                                         HourlyRate: e.target.value
                                                     }
                                                 })
                                             }}
                                             placeholder="Hourly Rate"/>
                            </FormGroup>
                            <FormGroup>
                                <ControlLabel>Status</ControlLabel>
                                <Select
                                    tabIndex="0"
                                    searchable={false}
                                    selectedOptions
                                    clearable={false}
                                    placeholder="Status"
                                    options={  [
                                        {value: 'Active', label: 'Active'},
                                        {value: 'Inactive', label: 'Inactive'}
                                    ]}
                                    onChange={(selectedOptions)=> this.setState({currentRecord:{
                                        ...this.state.currentRecord,
                                        Status: selectedOptions}})}
                                    value={this.state.currentRecord.Status }
                                />

                            </FormGroup>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer className="top20">
                        <Row className="left0">
                            <Col md={12} sm={12} xs={12} className="pleft0">
                                <Button className=" right0 pull-right btn btn-primary " type="button"
                                       disabled={this.state.pending}
                                        onClick={this.saveRecord.bind(this) }>
                                    Save
                                </Button>
                                <Button className="pull-right btn right20 btn-default" type="button"
                                        onClick={(e) => this.setState({showModal: false}) }>
                                    Cancel
                                </Button>
                            </Col>
                        </Row>
                    </Modal.Footer>
                </Modal>
                <RemoveModalDialog
                    show={this.state.removeRecordModalVisible}
                    removeRecord={
                       this.deleteRecord.bind(this)
                    }
                    closeModal={(e) => this.setState({currentRecord: false, removeRecordModalVisible: false})}>
                </RemoveModalDialog>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {'adminContractors': state.adminContractors,
        'userReducer': state.userReducer
    };

}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({makeRequest,displayMessage, dispatchAction}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminContractorsPage);
